import React, { useState, useEffect } from "react";
import "./RCPDF3.css";

const RCPDF3 = () => {

  const user = JSON.parse(localStorage.getItem("user"));

  const [rcno, setRcno] = useState("");
  const [loading, setLoading] = useState(false);
  const [response, setResponse] = useState(null);
  const [history, setHistory] = useState([]);

  useEffect(() => {
    fetchHistory();
  }, []);

  const fetchHistory = async () => {
    try {

      const res = await fetch(
        "https://rcfinder.online/api/get_rc_history.php"
      );

      const data = await res.json();

      if (data.status) {
        setHistory(data.data);
      }

    } catch (err) {
      console.log(err);
    }
  };

  const searchRC = async () => {

    if (!rcno) {
      alert("Enter RC Number");
      return;
    }

    setLoading(true);

    try {

      const res = await fetch(
        `https://rcfinder.online/api/rcpdf3.php?rcno=${rcno}&rctype=2&user_id=${user.id}`
      );

      const data = await res.json();

      console.log(data);

      if (data.sampleCode === "200") {

        setResponse(data);

        /*
        ========================
        SAVE HISTORY
        ========================
        */

        await fetch(
          "https://rcfinder.online/api/save_rc_history.php",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              rcno: data.rcno,
              fullname: data.fullname,
              fathername: data.fathername,
              front: data.front,
              back: data.back,
              Rc_Pdf: data.Rc_Pdf,
            }),
          }
        );

        fetchHistory();

      } else {

        alert(data.message || "RC Not Found");

      }

    } catch (err) {

      console.log(err);
      alert("Server Error");

    }

    setLoading(false);
  };

  return (

    <div className="rcpdf3-container">

      {/* SEARCH BOX */}

     <div className="search-card">

  <h2>RC PDF Search</h2>

  <input
    type="text"
    placeholder="Enter RC Number"
    value={rcno}
    onChange={(e) =>
      setRcno(e.target.value.toUpperCase())
    }
  />

  <p className="price-text">
    ₹100 will be deducted from wallet on successful search
  </p>

  <button onClick={searchRC}>

    {loading ? "Searching..." : "Search RC PDF ₹100"}

  </button>

</div>
      {/* RESULT */}

      {response && (

        <div className="result-card">

          <h2>Vehicle Details</h2>

          <div className="details-grid">

            <div>
              <span>RC Number</span>
              <p>{response.rcno}</p>
            </div>

            <div>
              <span>Owner Name</span>
              <p>{response.fullname}</p>
            </div>

            <div>
              <span>Father Name</span>
              <p>{response.fathername}</p>
            </div>

            <div>
              <span>Chassis Number</span>
              <p>{response.chassis_no}</p>
            </div>

            <div>
              <span>Engine Number</span>
              <p>{response.engine_no}</p>
            </div>

            <div>
              <span>Registration Date</span>
              <p>{response.reg_date}</p>
            </div>

            <div>
              <span>Expiry Date</span>
              <p>{response.exp_date}</p>
            </div>

          </div>

          {/* IMAGES */}


          {/* PDF BUTTON */}

          <a
            href={response.Rc_Pdf}
            target="_blank"
            rel="noreferrer"
            className="download-btn"
          >
            Download PDF
          </a>

        </div>

      )}

      {/* HISTORY */}

      <div className="history-card">

        <h2>RC Search History</h2>

        <table>

          <thead>

            <tr>

              <th>ID</th>
              <th>RC Number</th>
              <th>Owner</th>
              <th>Front</th>
              <th>PDF</th>

            </tr>

          </thead>

          <tbody>

            {history.map((item, index) => (

              <tr key={index}>

                <td>{item.id}</td>

                <td>{item.rcno}</td>

                <td>{item.fullname}</td>

                <td>

                  <img
                    src={item.front}
                    alt=""
                    className="history-img"
                  />

                </td>

                <td>

                  <a
                    href={item.rc_pdf}
                    target="_blank"
                    rel="noreferrer"
                  >
                    Download
                  </a>

                </td>

              </tr>

            ))}

          </tbody>

        </table>

      </div>

    </div>

  );
};

export default RCPDF3;